import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function FindPwKakaoCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const code = new URL(window.location.href).searchParams.get('code');
    if (!code) {
      alert('카카오 인증 실패');
      navigate('/find-pw');
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL || 'https://campus-life-production.up.railway.app';

    fetch(`${apiUrl}/api/auth/kakao/findpw?code=${code}`)
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          alert('카카오 인증 중 오류가 발생했습니다. 다시 시도해주세요.');
          navigate('/find-pw');
          return;
        }
        sessionStorage.setItem('findpwKakaoVerified', 'true');
        sessionStorage.setItem('findpwKakaoId', data.kakaoId || '');
        navigate('/find-pw');
      })
      .catch(() => {
        alert('카카오 인증 중 오류가 발생했습니다.');
        navigate('/find-pw');
      });
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p style={{ fontSize: '18px', color: '#666' }}>카카오 인증 처리 중...</p>
    </div>
  );
}

export default FindPwKakaoCallback;